export const MAX_ENTITIES = 1000;
